import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

export interface DoctorVisitsFaqItem {
  question: string;
  answer: string;
}

export interface DoctorVisitsFaqProps {
  items: DoctorVisitsFaqItem[];
}

export const DoctorVisitsFaq = ({ items }: DoctorVisitsFaqProps) => {
  const { t } = useTranslation("doctorVisits");

  return (
    <section id="visit-faq" tabIndex={-1} className="px-4 py-20 sm:px-6 sm:py-24 lg:px-8">
      <div className="mx-auto grid max-w-[1168px] gap-12 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">
            {t("faq.eyebrow")}
          </p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            {t("faq.title")}
          </h2>
        </div>

        <div className="divide-y divide-border border-y border-border">
          {items.map((item) => (
            <details key={item.question} className="group py-1">
              <summary className="flex min-h-16 cursor-pointer list-none items-center justify-between gap-5 py-4 text-left font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 [&::-webkit-details-marker]:hidden">
                <span>{item.question}</span>
                <ChevronDown
                  className="h-5 w-5 shrink-0 text-primary transition-transform duration-200 group-open:rotate-180"
                  aria-hidden="true"
                />
              </summary>
              <p className="max-w-3xl pb-6 pr-8 leading-7 text-muted-foreground">
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
